import type { ColumnDef } from "@tanstack/react-table";
import { useAuditLogs } from "@/api/audit";
import { usePagination } from "@/hooks/use-pagination";
import { DataTable } from "@/components/data-table/data-table";
import { Badge } from "@/components/ui/badge";
import { Select } from "@/components/ui/select";
import type { AuditLog } from "@/api/types";

const columns: ColumnDef<AuditLog, unknown>[] = [
  {
    accessorKey: "action",
    header: "Action",
    cell: ({ row }) => <Badge variant="accent">{row.original.action.replace("_", " ")}</Badge>,
  },
  { accessorKey: "user_email", header: "User" },
  { accessorKey: "target_type", header: "Target Type" },
  { accessorKey: "tenant_name", header: "Tenant" },
  { accessorKey: "ip_address", header: "IP Address" },
  {
    accessorKey: "created_at",
    header: "Timestamp",
    cell: ({ row }) => new Date(row.original.created_at).toLocaleString(),
  },
];

export function AuditLogsPage() {
  const { page, pageSize, search, params, setPage, setPageSize, setSearch, setFilter } = usePagination();
  const { data, isLoading } = useAuditLogs(params);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Audit Logs</h1>
      <DataTable
        columns={columns}
        data={data?.data ?? []}
        isLoading={isLoading}
        searchValue={search}
        onSearchChange={setSearch}
        searchPlaceholder="Search audit logs..."
        page={page}
        pageSize={pageSize}
        totalPages={data?.meta?.totalPages ?? 1}
        onPageChange={setPage}
        onPageSizeChange={setPageSize}
        total={data?.meta?.total}
        toolbar={
          <Select onChange={(e) => setFilter("action", e.target.value || null)} className="w-40">
            <option value="">All Actions</option>
            <option value="user_login">User Login</option>
            <option value="user_logout">User Logout</option>
            <option value="tenant_create">Tenant Create</option>
            <option value="tenant_update">Tenant Update</option>
            <option value="integration_config">Integration Config</option>
            <option value="sync_trigger">Sync Trigger</option>
            <option value="device_link">Device Link</option>
            <option value="device_unlink">Device Unlink</option>
            <option value="alert_acknowledge">Alert Acknowledge</option>
            <option value="alert_resolve">Alert Resolve</option>
          </Select>
        }
      />
    </div>
  );
}
